<template>
  <v-row>
    <v-col>
      <!-- <span>contact</span> -->
      <SendMessageForm mode="about" @onSubmit="sendMsg" />
      <AlertModal
              :show="modal"
              :message="modalMsg"
              @onConfirm="modal = false"
      ></AlertModal>
    </v-col>
  </v-row>
</template>

<script>
import SendMessageForm from "../form/SendMessageForm";
import AlertModal from "../modals/AlertModal";
import { mapState } from 'vuex';
export default {
  data: () => ({
    modal: false,
    modalMsg: ''
  }),
  computed: {
    ...mapState({
      branch_id: state => state.Branch.branch_id
    })
  },
  components: {
    SendMessageForm,
    AlertModal
  },
  methods: {
    sendMsg(form) {
      form.branch_id = this.branch_id;
      if (form.email && form.phone) {
        this.$store.dispatch('Contact/sendMsgContactBranch', form).then(() => {
          this.modalMsg = this.$t('messageBox.success');
          this.modal = true;
        });
      } else {
        this.modalMsg = this.$t('messageBox.notValid');
        this.modal = true;
      }
    }
  }
};
</script>

<style>
</style>
